"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _SurvivorReq = _interopRequireDefault(require("./SurvivorReq"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The SurvivorNew model module.
 * @module model/SurvivorNew
 * @version 1.0.0
 */
var SurvivorNew = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>SurvivorNew</code>.
   * @alias module:model/SurvivorNew
   */
  function SurvivorNew() {
    _classCallCheck(this, SurvivorNew);

    SurvivorNew.initialize(this);
  }
  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */


  _createClass(SurvivorNew, null, [{
    key: "initialize",
    value: function initialize(obj) {}
    /**
     * Constructs a <code>SurvivorNew</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SurvivorNew} obj Optional instance to populate.
     * @return {module:model/SurvivorNew} The populated <code>SurvivorNew</code> instance.
     */

  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new SurvivorNew();

        if (data.hasOwnProperty('case')) {
          obj['case'] = _ApiClient.default.convertToType(data['case'], 'Number');
        }

        if (data.hasOwnProperty('survivor')) {
          obj['survivor'] = _SurvivorReq.default.constructFromObject(data['survivor']);
        }
      }

      return obj;
    }
  }]);

  return SurvivorNew;
}();
/**
 * @member {Number} case
 */


SurvivorNew.prototype['case'] = undefined;
/**
 * @member {module:model/SurvivorReq} survivor
 */

SurvivorNew.prototype['survivor'] = undefined;
var _default = SurvivorNew;
exports.default = _default;